export default __webpack_public_path__ + "src/styles/fonts/icomoon.svg";